module.exports = __webpack_public_path__ + "static/media/3.9fb62a72.jpg";